<template>
  <div class="row letest-wrapper">
    <div
      class="col-md-4 col-sm-6 col-xs-12 my-2"
      v-for="item in items"
      :key="item.id"
    >
      <GameRounded :game="item" />
    </div>
  </div>
</template>

<script>
import GameRounded from "@/components/partials/GameRounded.vue";

export default {
  name: "NewGamesCarousel",
  components: {
    GameRounded,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

